<script setup lang="ts">

</script>

<template>
<div>
  <p class=" text-2xl font-extrabold">{{$t('house.big_quadrature')}}</p>
  <p class="text-gray-500 font-medium">{{$t('house.big_quadrature_info')}}</p>
</div>
</template>

<style scoped>

</style>